<template>
    <v-flex xs12>
      <v-card style="background: linear-gradient(#092646, #0b635b)" class="white--text mx-5">
        <v-card-title>
          <div v-for="(e,index) in user" :key="index" class="w-100 text-center">
            <h5 v-if="index!='pk' && e!=''">{{index}} : {{e}}</h5>
          </div>
        </v-card-title>
        <!-- </v-flex> -->
        <v-flex xs12 justify-center align-center>
          <v-img
            src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairTheCaesarSidePart&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light"
            height="150"
            contain
          ></v-img>
        </v-flex>
        <!-- </v-layout> -->
        <v-divider light></v-divider>
      </v-card>
    </v-flex>
</template>
<script>
export default {
  methods: {
    getUser() {
      return this.$store.getters["authentication/getUser"];
    },
    created() {
      this.$store.dispatch("users/getAll");
    }
  },
  created() {
    this.$store.dispatch("users/getAll");
  },
  data() {
    return {
      user: this.getUser()
    };
  }
};
</script>
